import { Component, ChangeDetectionStrategy, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { LocalizationService } from '@progress/kendo-angular-l10n';
import { getDate } from '@progress/kendo-date-math';
import { BusViewService } from './services/bus-view.service';
import { MIN_DATE, MAX_DATE } from '../defaults';
import { dateInRange, getToday, isInRange } from '../util';
/**
 * @hidden
 */
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(bus, localization) {
        this.bus = bus;
        this.localization = localization;
        this.navigate = true;
        this.todayIsInRange = true;
        this.min = new Date(MIN_DATE);
        this.max = new Date(MAX_DATE);
        this.today = new EventEmitter();
    }
    Object.defineProperty(HeaderComponent.prototype, "getComponentClass", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.ngOnChanges = function (_) {
        var service = this.bus.service(this.activeView);
        if (!service) {
            return;
        }
        this.todayIsInRange = isInRange(getToday(), getDate(this.min), getDate(this.max));
        this.todayMessage = this.localization.get('today');
        this.navigate = this.bus.canMoveUp(this.activeView);
        this.title = this.currentDate ? service.title(this.currentDate) : '';
    };
    HeaderComponent.prototype.handleTodayClick = function () {
        if (!this.todayIsInRange) {
            return;
        }
        this.bus.moveToBottom(this.activeView);
        this.today.emit(dateInRange(getToday(), this.min, this.max));
    };
    HeaderComponent.prototype.handleNavigation = function () {
        if (!this.navigate) {
            return;
        }
        this.bus.moveUp(this.activeView);
    };
    HeaderComponent.decorators = [
        { type: Component, args: [{
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    selector: 'kendo-calendar-header',
                    template: "\n    <span class=\"k-button k-bare k-title\" [class.k-state-disabled]=\"!navigate\" (click)=\"handleNavigation()\">\n        {{title}}\n    </span>\n    <span class=\"k-today\" [class.k-state-disabled]=\"!todayIsInRange\" (click)=\"handleTodayClick()\">\n        {{todayMessage}}\n    </span>\n  "
                },] },
    ];
    /** @nocollapse */
    HeaderComponent.ctorParameters = function () { return [
        { type: BusViewService, },
        { type: LocalizationService, },
    ]; };
    HeaderComponent.propDecorators = {
        'activeView': [{ type: Input },],
        'currentDate': [{ type: Input },],
        'min': [{ type: Input },],
        'max': [{ type: Input },],
        'today': [{ type: Output },],
        'getComponentClass': [{ type: HostBinding, args: ["class.k-calendar-header",] },],
    };
    return HeaderComponent;
}());
export { HeaderComponent };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dateinputs/dist/es/calendar/header.component.js
// module id = ../../../../@progress/kendo-angular-dateinputs/dist/es/calendar/header.component.js
// module chunks = vendor